import React from 'react';
import { useSelector } from 'react-redux';
import { Alert, Card } from 'antd';
import { useTranslation } from 'react-i18next';
import { ApplicationState } from '../../reducers';
import { hasPermission } from '../../utils/Permissions';
import AdoptionImportPage from '../../pages/distribution/AdoptionImportPage';

const AdoptionImportContainer: React.FC = () => {
  const { t } = useTranslation();
  const user = useSelector((state: ApplicationState) => state.user.user);

  const canAccessAdoptionImport = hasPermission(user, 'can_access_adoption_import');

  if (!canAccessAdoptionImport) {
    return (
      <div className="distribution-import-container">
        <Card>
          <Alert
            message={t('receiver:accessDenied')}
            description={t('receiver:noPermissionAdoptionImport')}
            type="warning"
            showIcon
          />
        </Card>
      </div>
    );
  }

  return <AdoptionImportPage />;
};

export default AdoptionImportContainer;
